import { authPaths } from "components/router/routes";
import { FlowFFragment, UserFFragment } from "generated/graphql";

const handleSetupStage = (
  currentPathName: string,
  currentFlow: FlowFFragment
) => {
  if (currentFlow.stage !== "setup") return null;
  switch (currentFlow.page) {
    case 1:
      return currentPathName !== `${authPaths.CONNECT}/${currentFlow.setupType}`
        ? `${authPaths.CONNECT}/${currentFlow.setupType}`
        : null;
    case 2:
      return currentPathName !== `${authPaths.VERIFY_SETUP}/Athena`
        ? `${authPaths.VERIFY_SETUP}/Athena`
        : null;

    default:
      return null;
  }
};
const handleProcessingStage = (
  currentPathName: string,
  currentFlow: FlowFFragment
) => {
  if (currentFlow.stage !== "processing") return null;
  switch (currentFlow.page) {
    default:
      return !currentPathName.startsWith(authPaths.ATHENA_RESULTS_PROCESSING)
        ? authPaths.ATHENA_RESULTS_PROCESSING
        : null;
  }
};
const handleResultsStage = (
  currentPathName: string,
  currentFlow: FlowFFragment
) => {
  if (currentFlow.stage !== "results") return null;
  switch (currentFlow.page) {
    default:
      return !currentPathName.startsWith(authPaths.DIAGNOSTIC_DASHBOARD)
        ? authPaths.DIAGNOSTIC_DASHBOARD
        : null;
  }
};
export const getNextOnboardingAthenaPath = (
  currentPathName: string,
  user: UserFFragment | null,
  flows: FlowFFragment[] | null | undefined,
  currentFlow: FlowFFragment | null | undefined,
  next: string | null
) => {
  if (!user) {
    if (
      currentPathName === authPaths.SIGNIN ||
      currentPathName === authPaths.SIGNUP ||
      currentPathName === authPaths.VERIFY_CODE
    ) {
      return null;
    }
    return authPaths.SIGNIN;
  }

  if (!flows || flows.length === 0 || !currentFlow) {
    if (!currentPathName.startsWith(authPaths.CONNECT)) {
      return authPaths.CONNECT;
    }
    return null;
  }
  if (currentFlow) {
    switch (currentFlow.stage) {
      case "setup":
        return handleSetupStage(currentPathName, currentFlow);
      case "processing":
        return handleProcessingStage(currentPathName, currentFlow);
      case "results":
        return handleResultsStage(currentPathName, currentFlow);
      default:
        return null;
    }
  }
  return null;
};
